import {EventService} from "./eventService";
import {PersistService} from "./persistService";

export var ResultService = (function () {

    var partiData = null;
    // ---
    // PUBLIC METHODS.
    // ---

    function getProeveId() {
        return partiData.proeveId;
    }

    function getProeveDato() {
        return partiData.proeveDato;
    }

    function isVmMesterskap() {
        return partiData.vmMesterskap;
    }

    function getDeltakere() {
        return partiData.partiHunder;
    }

    function getKlasse() {
        return partiData.klasse;
    }

    function isCaciobPaaProeve() {
        if (partiData.internasjonalProeve && partiData.klasse.klasseId.indexOf("LPE") > -1)
            return true;
        return false;
    }

    function getDommerNavn() {
        return partiData.dommerNavn1;
    }

    function isEkvipasjeFerdigRegistrert(oevelser) {
        for (var i = 0; i < oevelser.length; i++) {
            var sum = 0;
            if (partiData.hovedparti) {
                sum = getOevelsePoengSum(oevelser[i].koeffisient, oevelser[i].oppnaaddPoeng);
                if (oevelser[i].koeffisient !== null && sum === null) {
                    return false;
                }
            } else {
                var nr = i + 1;
                if (nr >= partiData.klasse.fraOevelse && nr <= partiData.klasse.tilOevelse) {
                    sum = getOevelsePoengSum(oevelser[i].koeffisient, oevelser[i].oppnaaddPoeng);
                    if (oevelser[i].koeffisient !== null && sum === null) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    function getPoengTotalt(oevelser, gultKort) {
        var sum = 0;
        for (var i = 0; i < oevelser.length; i++) {
            sum += getOevelsePoengSum(oevelser[i].koeffisient, oevelser[i].oppnaaddPoeng);
        }
        if (gultKort) {
            sum -= 10;
        }
        return sum;
    }

    function getPartiHund(katanr) {
        for (var i=0; i<partiData.partiHunder.length; i++) {
            if (partiData.partiHunder[i].hund.katalogNr === katanr) {
                return partiData.partiHunder[i];
            }
        }
        return null;
    }

    function isPoengOgKommentarerRegistrert(katanr) {
        var partiHund = getPartiHund(katanr);
        if (partiHund !== null) {
            var poengTotalt = getPoengTotalt(partiHund.hund.resultat.oevelseResultat, false);
            if (poengTotalt > 0) return true;
            return isKommentarRegistrert(partiHund.hund.resultat.oevelseResultat);
        }
        return false;
    }

    function isKommentarRegistrert(oevelser) {
        for (var i = 0; i < oevelser.length; i++) {
            if (oevelser[i].dommerKommentar !== null && oevelser[i].dommerKommentar.trim() !== '' ) {
                return true;
            }
        }
        return false;
    }

    function getDeltaker(katanr) {

        var partiHund = getPartiHund(katanr);

        //var partiHund = partiData.partiHunder.find(function (partiHund) { return partiHund.hund.katalogNr === katanr; });
        if (partiHund !== null && partiHund !== undefined) {

            var deltakerHund = {};
            deltakerHund.lnr = partiHund.lnr;
            deltakerHund.katalogNr = partiHund.hund.katalogNr;
            deltakerHund.regNr = partiHund.hund.regNr;
            deltakerHund.navn = partiHund.hund.navn;
            deltakerHund.rase = partiHund.hund.rase;
            deltakerHund.klasse = partiHund.hund.klasse;
            deltakerHund.resultat = partiHund.hund.resultat;
            return deltakerHund;
        }
        return null;
    }

    function getKritikkOevelserTilDeltaker(katanr) {
        //var partiHund = partiData.partiHunder.find(function (partiHund) { return partiHund.hund.katalogNr === katanr; });
        var partiHund = getPartiHund(katanr);
        if (partiHund !== null && partiHund !== undefined) {
            return partiHund.hund.resultat.oevelseResultat;
        }
        return [];
    }

    function isKlasseDeltPaaOevelser() {
        return partiData.klasse.deltPaaOevelser;
    }

    function getFraOevelse() {
        if (isKlasseDeltPaaOevelser) {
            return partiData.klasse.fraOevelse;
        }
        return null;
    }

    function getTilOevelse() {
        if (isKlasseDeltPaaOevelser) {
            return partiData.klasse.tilOevelse;
        }
        return null;
    }

    function isHovedparti() {
      return partiData.hovedparti;
    }

    function isInternasjonal() {
        return partiData.internasjonalProeve;
    }

    function getDelPartiCheckedIn() {
        return partiData.delPartiCheckedIn;
    }

    function getDelPartiCheckedOut() {
        return partiData.delPartiCheckedOut;
    }

    function getUnderKlassePartier() {
        if (partiData.underKlassePartier != null) {
            return partiData.underKlassePartier;
        }
        return [];
    }

    function setParti(data) {
        partiData = data;
        if (data) {
            EventService.setParti(partiData.proeveId, partiData.partiId, partiData.klasse.klasseId, partiData.klasse.hovedklassePartiId, partiData.token);
        } else {
            EventService.setParti(null, null, null, null, null);
        }
    }

    function checkOutParti(proeveId, passord, partiId) {
        return new Promise(function(resolve, reject) {
            PersistService.checkOutPartiFromServer(proeveId, passord, partiId)
                .then((parti)=> {
                    setParti(parti);
                    setEkvipasjeFerdigRegistrertStatuser();
                    savePartiData();
                })
            .then(resolve)
            .catch(reject);
        });
    }

    function setEkvipasjeFerdigRegistrertStatuser() {
        if (!partiData.hovedparti) {
            for (var i=0; i<partiData.partiHunder.length; i++) {
                var ferdig = false;
                var resultat = partiData.partiHunder[i].hund.resultat;
                if (resultat.ikkeMoedt || resultat.roedtKort || isEkvipasjeFerdigRegistrert(resultat.oevelseResultat)) {
                    ferdig = true;
                }
                if (resultat.ekvipasjeFerdigRegistrert !== ferdig) {
                    partiData.partiHunder[i].hund.resultat.ekvipasjeFerdigRegistrert = ferdig;
                }
            }
        }
    }




    function isPartiInLocalStorage() {
        var p = PersistService.loadPartiData();
        setParti(p);
        //buildStat();
        if (p !== null) {
            return true;
        }
        return false;
    }



    function isKlassePartiFerdigBedoemt() {
        for (var i = 0; i < partiData.partiHunder.length; i++) {
            var resultat = partiData.partiHunder[i].hund.resultat;
            if (!resultat.ekvipasjeFerdigRegistrert && !resultat.ikkeMoedt && !resultat.roedtKort) {
                return false;
            }
        }
        if (partiData.underKlassePartier.length > 0) {
            for (var j = 0; j < partiData.underKlassePartier.length; j++) {
                if (partiData.underKlassePartier[j].checkedOut === null) {
                    return false;
                }
            }
        }
        return true;
    }

    function checkInParti() {
        return new Promise(function(resolve, reject) {
            if (EventService.getAntallEvents() > 0) {
                throw Error("Du må ikke sjekke inn! Alle resultater skal først overføres til server.");
            }

            PersistService.checkInToServer(partiData)
                .then((parti)=> {
                    PersistService.deletePartiData();
                    EventService.deleteEventsFromLocalStorage();
                    setParti(null);
                })
                .then(resolve)
                .catch(reject);
        });
    }


    function checkInDelKlasseParti() {
        return new Promise(function(resolve, reject) {

            if (!isKlassePartiFerdigBedoemt()) {
                throw Error("Alle resultater må registreres før en kan sjekke ind klassen.");
            }
            if (EventService.getAntallEvents() > 0) {
                throw Error("Du må ikke sjekke inn! Alle resultater skal først overføres til server.");
            }

            PersistService.checkInDelKlasseParti(partiData)
                .then((parti)=> {
                    partiData.delPartiCheckedIn = new Date();
                    savePartiData();
                    PersistService.savePartiData(partiData);
                })
                .then(resolve)
                .catch(reject);
        });
    }

    function getIndex(deltagere, katalogNr) {
        for (var i = 0; i < deltagere.length; i++) {
            if (deltagere[i].hund.katalogNr === katalogNr) {
                return i;
            }
        }
        return null;
    }

    function changeKlasseParti(katalogNr, lnr, nyPartiId) {
        return new Promise(function(resolve, reject) {
            PersistService.changeKlasseParti(partiData, katalogNr, lnr, nyPartiId)
                .then(()=> {
                    var deltagere = getDeltakere();
                    var index = getIndex(deltagere, katalogNr);
                    if (index !== null) {
                        deltagere.splice(index, 1);
                    }
                    savePartiData();
                })
            .then(resolve)
            .catch(reject);
        });

    }

    function cancel() {
        if (window.confirm("Fortryd? Vær oppmærksom på at alle resultater som ikke er overført til server vil bli slættet for alltid.")) {
            PersistService.deletePartiData();
            EventService.deleteEventsFromLocalStorage();
            setParti(null);
        }
    }

    function getParti() {
        return partiData;
    }

    function getKlassePartier(proeveId, passord) {
        return PersistService.getKlassePartier(proeveId, passord);
    }

    function getAndreMuligeKlassePartier() {
        var ret = [];
        PersistService.getKlassePartier(partiData.proeveId, partiData.passord)
            .then((klassePartier)=>{

                for (var i = 0; i < klassePartier.length; i++) {
                    if (klassePartier[i].klasse.klasseId !== partiData.klasse.klasseId) {
                        ret.push(klassePartier[i]);
                    }
                }

            })
            .catch((err)=> {
                alert(err.message);
            });
        return ret;
    }

    function getNeste(katalogNr, ikkeIM) {
        var deltakere = getDeltakere();
        for (var i=0; i<deltakere.length; i++) {
            if (deltakere[i].hund.resultat.katalogNr === katalogNr) {
                break;
            }
        }
        i++;
        if (ikkeIM && deltakere[i]) {
            var nesteDeltaker = deltakere[i];
            while (nesteDeltaker && nesteDeltaker.hund.resultat.ikkeMoedt) {
                i++;
                nesteDeltaker = deltakere[i];
            }
        }
        if (deltakere[i]) {
            return deltakere[i].hund.resultat.katalogNr;
        }
        return null;
    }

    function getForrige(katalogNr, ikkeIM) {
        var deltakere = getDeltakere();
        for (var i=0; i<deltakere.length; i++) {
            if (deltakere[i].hund.resultat.katalogNr === katalogNr) {
                break;
            }
        }
        i--;
        if (ikkeIM && deltakere[i]) {
            var nesteDeltaker = deltakere[i];
            while (nesteDeltaker && nesteDeltaker.hund.resultat.ikkeMoedt) {
                i--;
                nesteDeltaker = deltakere[i];
            }
        }
        if (deltakere[i]) {
            return deltakere[i].hund.resultat.katalogNr;
        }
        return null;
    }

    function setGultKort(hund, gultKort) {
        if (hund.resultat.gultKort !== gultKort) {
            EventService.sendGultKortEvent(hund.lnr, hund.katalogNr, gultKort);
            var poengTotalt = getPoengTotalt(hund.resultat.oevelseResultat, gultKort);
            setPremiegrad(hund, poengTotalt);
            hund.resultat.gultKort = gultKort;
            hund.resultat.poengTotalt = poengTotalt;
            return true;
        }
        return false;
    }

    function setRoedtKort(hund, roedtKort) {
        if (hund.resultat.roedtKort !== roedtKort) {
            EventService.sendRoedtKortEvent(hund.lnr, hund.katalogNr, roedtKort);
            hund.resultat.roedtKort = roedtKort;
            if (roedtKort) {
                setPremiegrad(hund, null);
                hund.resultat.poengTotalt = null;
            }
            else {
                var poengTotalt = getPoengTotalt(hund.resultat.oevelseResultat, hund.resultat.gultKort);
                //console.log("Poengtotalt: " + poengTotalt)
                setPremiegrad(hund, poengTotalt);
                hund.resultat.ekvipasjeFerdigRegistrert = isEkvipasjeFerdigRegistrert(hund.resultat.oevelseResultat);
                hund.resultat.poengTotalt = poengTotalt;
            }
            return true;
        }
        return false;
    }


    function setCaciob(hund, caciob) {
        if (hund.resultat.caciob !== caciob) {
            if (hund.resultat.caciob === "CACIOB") {
                EventService.sendCaciobEvent(hund.lnr, hund.katalogNr, false);
            } else if (hund.resultat.caciob === "RCACIOB") {
                EventService.sendReserveCaciobEvent(hund.lnr, hund.katalogNr, false);
            }
            if (caciob === "CACIOB") {
                EventService.sendCaciobEvent(hund.lnr, hund.katalogNr, true);
            } else if (caciob === "RCACIOB") {
                EventService.sendReserveCaciobEvent(hund.lnr, hund.katalogNr, true);
            }
            hund.resultat.caciob = caciob;
            return true;
        }
        return false;
    }

    function setTittel(hund, premiegrad) {
        if (partiData.hovedparti) {
            if (hund.resultat.premiegrad !== premiegrad) {
                //console.log("Klasse:" + hund.klasse);
                var tittelId = getTittel(hund.klasse, premiegrad);
                if (hund.resultat.tittelId !== tittelId) {
                    EventService.sendTittelEndretEvent(hund.lnr, hund.katalogNr, tittelId);
                    hund.resultat.tittelId = tittelId;
                }
            }
        }
    }

    function setPremiegrad(hund, poengTotalt) {
        if (partiData.hovedparti) {
            var tidligerePremiegrad = hund.resultat.premiegrad;
            var nyPremiegrad = getPremiegrad(hund.klasse, poengTotalt);
            if (tidligerePremiegrad !== nyPremiegrad && tidligerePremiegrad !== null && tidligerePremiegrad === 1) {
                setCaciob(hund, null);
            }
            if (tidligerePremiegrad !== nyPremiegrad) {
                setTittel(hund, nyPremiegrad);
                EventService.sendPremiegradEndretEvent(hund.lnr, hund.katalogNr, nyPremiegrad);
            }
            hund.resultat.premiegrad = nyPremiegrad;
        }
    }

    function getTittel(klasse, premiegrad) {
        if (premiegrad !== null && premiegrad === 1) {
            if (klasse.startsWith("LP1")) {
                return 115;
            }
            else if (klasse.startsWith("LP2")) {
                return 116;
            }
            else if (klasse.startsWith("LP3")) {
                return 117;
            }
            else if (klasse.startsWith("LPE")) {
                return 118;
            }
            else if (klasse.startsWith("LPJ")) {
                return 1566;
            }
        }
        return null;
    }


    function getOevelsePoengSum(koeffisient, poeng) {
        if (koeffisient !== null && poeng !== null && poeng !== '') {
            return poeng * koeffisient;
        }
        else {
            return null;
        }
    }


    function setIkkeMoedt(katalogNr, ikkeMoedt) {
        var deltaker = getDeltakerHund(katalogNr);
        var changes = false;
        if (deltaker.hund.resultat.ikkeMoedt !== ikkeMoedt) {
            changes = true;
            if (ikkeMoedt) {
                setPlassering(deltaker.hund, null);
                setPremiegrad(deltaker.hund, null);
                setCaciob(deltaker.hund, null);
                setGultKort(deltaker.hund, false);
                setRoedtKort(deltaker.hund, false);
                if (partiData.hovedparti) {
                    EventService.sendIkkeMoedtEvent(deltaker.hund.lnr, katalogNr, ikkeMoedt);
                }
                var oevelser = deltaker.hund.resultat.oevelseResultat;
                for (var i = 0; i < oevelser.length; i++) {
                    if (!partiData.hovedparti) {
                        setOevelsePoeng(deltaker.hund, oevelser[i], null)
                    }
                    oevelser[i].poengSum = null;
                    oevelser[i].oppnaaddPoeng = null;
                    oevelser[i].dommerKommentar = null;
                }
                deltaker.hund.resultat.poengTotalt = 0;
            } else {
                if (partiData.hovedparti) {
                    EventService.sendIkkeMoedtEvent(deltaker.hund.lnr, katalogNr, ikkeMoedt);
                }
                deltaker.hund.resultat.ekvipasjeFerdigRegistrert = false;
            }
            deltaker.hund.resultat.ikkeMoedt = ikkeMoedt;
            updatePlasseringer();
        }
        if (changes) {
            savePartiData();
        }
    }

    function oppdaterPoeng(katalogNr, oevelseNr, poeng) {
        var deltaker = getDeltakerHund(katalogNr);
        var changes = false;

        var oevelse = getOevelse(deltaker.hund.resultat.oevelseResultat, oevelseNr);
        if (poeng === '') {
            poeng = null;
        }
        if (oevelse.oppnaaddPoeng !== poeng) {
            changes = setOevelsePoeng(deltaker.hund, oevelse, poeng);
            var ekvipasjeFerdigRegistrert = deltaker.hund.resultat.ekvipasjeFerdigRegistrert;
            var plassering = deltaker.hund.resultat.plassering;
            if (!ekvipasjeFerdigRegistrert && plassering !== null) {
                slettPlasseringer();
            } else {
                updatePlasseringer();
            }
        }
        if (changes) {
            savePartiData();
        }
    }

    function slettPlasseringer() {
        for (var i = 0; i < partiData.partiHunder.length; i++) {
            setPlassering(partiData.partiHunder[i].hund, null);
        }
    }

    function oppdaterCaciob(katalogNr, caciob) {
        var deltaker = getDeltakerHund(katalogNr);
        var changes = false;
        if (deltaker.hund.resultat.caciob !== caciob) {
            changes = true;
            setCaciob(deltaker.hund, caciob);
        }
        if (changes) {
            savePartiData();
        }
    }

    function oppdaterGultKort(katalogNr, gultKort) {
        var changes = false;
        var deltaker = getDeltakerHund(katalogNr);
        if (deltaker.hund.resultat.gultKort !== gultKort) {
            setGultKort(deltaker.hund, gultKort)
            updatePlasseringer();
            changes = true;
        }
        if (changes) {
            savePartiData();
        }
    }

    function oppdaterRoedtKort(katalogNr, roedtKort) {
        var changes = false;
        var deltaker = getDeltakerHund(katalogNr);
        if (deltaker.hund.resultat.roedtKort !== roedtKort) {
            setCaciob(deltaker.hund, null);
            setRoedtKort(deltaker.hund, roedtKort)
            updatePlasseringer();
            changes = true;
        }
        if (changes) {
            savePartiData();
        }
    }

    function oppdaterKommentar(katalogNr, oevelseNr, kommentar) {
        var deltaker = getDeltakerHund(katalogNr);
        var changes = false;
        if (kommentar === '') {
            kommentar = null;
        }
        var oevelse = getOevelse(deltaker.hund.resultat.oevelseResultat, oevelseNr);
        if (oevelse.dommerKommentar !== kommentar) {
            changes = true;
            EventService.sendOevelseDommerKommentarEndretEvent(deltaker.hund.lnr, katalogNr, oevelseNr, oevelse.navn, kommentar, oevelse.koeffisient);
            oevelse.dommerKommentar = kommentar;
        }
        if (changes) {
            savePartiData();
        }
    }
    //private methods

    function getDeltakerHund(katalogNr) {
        //return partiData.partiHunder.find(function (partiHund) { return partiHund.hund.katalogNr === katalogNr; });
        return getPartiHund(katalogNr);
    }


    function getOevelse(oevelser, oevelseNr) {
        for (var i=0; i<oevelser.length; i++) {
            if (oevelser[i].nr === oevelseNr) {
                return oevelser[i];
            }
        }
        return null;
        //return oevelser.find(function (oevelse) { return oevelse.nr === oevelseNr; });
    }

    function getPremiegrad(klasse, poengTotalt) {
        if (poengTotalt === null || poengTotalt=== '') {
            return null;
        }
        if (klasse.indexOf("LP1") > -1 || klasse.indexOf("LPJ") > -1) {
            if (poengTotalt >= 160) {
                return 1;
            }
            else if (poengTotalt >= 140 && poengTotalt <= 159.5) {
                return 2;
            }
            else if (poengTotalt >= 120 && poengTotalt <= 139.5) {
                return 3;
            }
        }
        else if (klasse.indexOf("LP2") > -1) {
            if (poengTotalt >= 224) {
                return 1;
            }
            else if (poengTotalt >= 196 && poengTotalt <= 223.5) {
                return 2;
            }
            else if (poengTotalt >= 168 && poengTotalt <= 195.5) {
                return 3;
            }
        }
        else if (klasse.indexOf("LP3") > -1 || klasse.indexOf("LPE") > -1 || klasse.indexOf("LPC") > -1) {
            if (poengTotalt >= 256) {
                return 1;
            }
            else if (poengTotalt >= 224 && poengTotalt <= 255.5) {
                return 2;
            }
            else if (poengTotalt >= 192 && poengTotalt <= 223.5) {
                return 3;
            }
        }
        return null;
    }

    function setOevelsePoeng(hund, oevelse, poeng) {
        var tidligerePoeng = null;
        if (oevelse.oppnaaddPoeng !== null) {
            tidligerePoeng = Number(oevelse.oppnaaddPoeng);
        }
        var nyPoeng = null;
        if (poeng !== null) {
            nyPoeng = Number(poeng);
        }
        //console.log("tidligerePoeng:" + tidligerePoeng + ", nyepoeng:" + nyPoeng);
        if (tidligerePoeng !== nyPoeng) {
            var nyOevelsePoengSum = getOevelsePoengSum(oevelse.koeffisient, poeng);
            var tidligereOevelsePoengSum = getOevelsePoengSum(oevelse.koeffisient, oevelse.oppnaaddPoeng);

            //valider poeng begrensning
            var poengTotalt = hund.resultat.poengTotalt;
            if (tidligereOevelsePoengSum !== null) {
                poengTotalt = poengTotalt - tidligereOevelsePoengSum;
            }
            if (nyOevelsePoengSum !== null) {
                poengTotalt = poengTotalt + nyOevelsePoengSum;
            }

            if (poengTotalt > 200 && hund.klasse.indexOf("LP1") > -1) {
                alert("Max poeng i klasse 1 er 200 point");
                return false;
            }
            else if (poengTotalt > 200 && hund.klasse.indexOf("LP1") > -1) {
                alert("Max poeng i junior klasse er 200 point");
                return false;
            }
            else  if (poengTotalt > 280 && hund.klasse.indexOf("LP2") > -1) {
                alert("Max poeng i klasse 2 er 280 point");
                return false;
            }
            else  if (poengTotalt > 320 && (hund.klasse.indexOf("LP3") > -1 || hund.klasse.indexOf("LPE") > -1 || hund.klasse.indexOf("LPC") > -1)) {
                alert("Max poeng i " + hund.klasse + " 320 point");
                return false;
            }

            setPremiegrad(hund, poengTotalt);

            //send Event
            EventService.sendOevelsePoengEndretEvent(hund.lnr, hund.katalogNr, oevelse.nr, oevelse.navn, poeng, oevelse.koeffisient);
            oevelse.poengSum = nyOevelsePoengSum;
            oevelse.oppnaaddPoeng = poeng;
            hund.resultat.poengTotalt = poengTotalt;
            hund.resultat.ekvipasjeFerdigRegistrert = isEkvipasjeFerdigRegistrert(hund.resultat.oevelseResultat);


            return true
        }
        return false;
    }

    function reloadFromLocalStorage() {
        setParti(PersistService.loadPartiData());
        EventService.loadEventsFromLocalStorage();
    }

    function savePartiData() {
        try {
            if (partiData != null) {
                //buildStat();
                PersistService.savePartiData(partiData);
            }
        } catch(err) {
            var msg = err.message;
            if (!msg) msg = err;
            alert("En fejl har oppstået: " + msg);
        }
    }

    function checkOutUnderKlasseParti(underKlassePartiId) {
        return new Promise(function(resolve, reject) {
            if (EventService.getAntallEvents() > 0) {
                throw Error("Alle resultater skal først overføres til server.");
            }

            PersistService.checkOutUnderKlasseParti(partiData, underKlassePartiId)
                .then((parti)=> {
                    for (var i = 0; i < parti.partiHunder.length; i++) {
                        var partiHund = getPartiHund(parti.partiHunder[i].hund.katalogNr);
                        if (partiHund != null) {
                            if (!partiHund.hund.resultat.roedtKort && parti.partiHunder[i].hund.resultat.roedtKort){
                                setPremiegrad(partiHund.hund, null);
                            } else {
                                setPremiegrad(partiHund.hund, parti.partiHunder[i].hund.resultat.poengTotalt);
                            }
                            partiHund.hund.resultat.gultKort = parti.partiHunder[i].hund.resultat.gultKort;
                            partiHund.hund.resultat.roedtKort = parti.partiHunder[i].hund.resultat.roedtKort;
                            partiHund.hund.resultat.oevelseResultat = parti.partiHunder[i].hund.resultat.oevelseResultat;
                            partiHund.hund.resultat.poengTotalt = parti.partiHunder[i].hund.resultat.poengTotalt;
                            if (partiHund.hund.resultat.ikkeMoedt || partiHund.hund.resultat.roedtKort) {
                                partiHund.hund.resultat.ekvipasjeFerdigRegistrert = true;
                                //console.log(partiHund.hund.katalogNr + ", " + partiHund.hund.resultat.ekvipasjeFerdigRegistrert);
                            }
                            else {
                                partiHund.hund.resultat.ekvipasjeFerdigRegistrert = isEkvipasjeFerdigRegistrert(partiHund.hund.resultat.oevelseResultat);
                            }

                        }
                    }
                    savePartiData();

                })
                .then(resolve)
                .catch(reject);
        });
    }

    function isUnderklasserPartierCheckedOut() {
        if (partiData.underKlassePartier != null) {
            //console.log(partiData.underKlassePartier);
            for (var i = 0; i < partiData.underKlassePartier.length; i++) {
                if (partiData.underKlassePartier.checkedOut === null) {
                    return false;
                }
            }
        }
        return true;
    }

    function updateUnderKlassePartier() {
        return new Promise(function(resolve, reject) {
            var ret = [];
            if (partiData.underKlassePartier != null && partiData.underKlassePartier.length > 0) {
                PersistService.getUnderKlassePartierFromServer(partiData.proeveId, partiData.partiId, partiData.token)
                    .then((klassePartier)  => {
                        for (var i = 0; i < klassePartier.length; i++) {
                            ret.push(klassePartier[i]);
                        }
                        partiData.underKlassePartier = ret;
                        savePartiData();
                    })
                    .then(resolve)
                    .catch(reject);
            }

        });
    }


    function getDeltakerListe(katalognrRekkefoelge) {
        var deltakere = getDeltakere().slice();
        //console.log("getDeltakerListe");
        //console.log(deltakere);
        if (!katalognrRekkefoelge) {
            deltakere.sort(plasseringRekkefoelgeComporator);
        }
        return deltakere;
    }

    function plasseringRekkefoelgeComporator(a, b) {
        if (a.hund.resultat.plassering > b.hund.resultat.plassering)
            return 1;
        else if (a.hund.resultat.plassering < b.hund.resultat.plassering)
            return -1;
        else {
            return katalognrRekkefoelgeComporator(a, b);
        }
    }

    function katalognrRekkefoelgeComporator(a, b) {
        if (a.hund.resultat.katalogNr > b.hund.resultat.katalogNr)
            return 1;
        else
            return -1;
    }



    function getHunderTilPlassering() {
        var ret = [];
        for (var i = 0; i < partiData.partiHunder.length; i++) {
            var resultat = partiData.partiHunder[i].hund.resultat;
            if (!resultat.ikkeMoedt && (resultat.ekvipasjeFerdigRegistrert || resultat.roedtKort)) {
                ret.push(resultat);
            }
        }
        ret.sort(poengTotalComporator);
        return ret;
    }

    function updatePlasseringer() {
        var status = isKlassePartiFerdigBedoemt();
        if (partiData.hovedparti && status) {
            var ret = getHunderTilPlassering();
            for (var j=0; j<ret.length; j++) {
                var partiHund = getDeltakerHund(ret[j].katalogNr);
                setPlassering(partiHund.hund, (j + 1));
            }
        }
        else {
            //slettPlasseringer();
        }
        //console.log("finished updatePlasseringer");
    }



    function setPlassering(hund, plassering) {
        var changes = false;
        if (hund.resultat.plassering !== plassering) {
            console.log(hund.katalogNr + ". poengtotalt: " + hund.resultat.poengTotalt + ", Placering:" + plassering);
            changes = true;
            EventService.sendPlasseringEndretEvent(hund.lnr, hund.katalogNr, plassering);
            hund.resultat.plassering = plassering;
        }
        return changes;
    }

    function poengTotalComporator(a, b) {
        if (a.poengTotalt < b.poengTotalt)
            return 1;
        else if (a.poengTotalt > b.poengTotalt)
            return -1;
        else {
            var oevelseNrList = getOevelseNrListVedTotalPoengLikhet(a.klasse);
            var sumA = getPoengSum(a, oevelseNrList);
            var sumB = getPoengSum(b, oevelseNrList);
            if (sumA < sumB)
                return 1;
            else if (sumA > sumB)
                return -1;
        }
        return 0;
    }

    function getPoengSum(resultat, oevelseNrList)  {
        var sum = 0;
        for (var i=0; i < oevelseNrList.length; i++) {
            var oppnaaddPoeng = Number(resultat.oevelseResultat[oevelseNrList[i] - 1].oppnaaddPoeng);
            //console.log("opnådd poeng: " + oppnaaddPoeng);
            if (oppnaaddPoeng !== null) {
                sum += oppnaaddPoeng;
            }
        }
        return sum;
    }

    function getOevelseNrListVedTotalPoengLikhetFraOgMed2026(klasse) {
        if (klasse.indexOf("LP1") > -1 || klasse.indexOf("LPJ-1") > -1) {
            return [2, 5, 8];
        }
        else if (klasse.indexOf("LP2") > -1) {
            return [3, 9, 11];
        }
        else if (klasse.indexOf("LP3") > -1) {
            return [3, 5, 6];
        }
        else if (klasse.indexOf("LPC") > -1) {
            return [3, 5, 6];
        }
        else if (klasse.indexOf("LPE") > -1) {
            return [3, 5, 6];
        }
        return [];
    }

    function getOevelseNrListVedTotalPoengLikhetFoer2026(klasse) {
        if (klasse.indexOf("LP1") > -1 || klasse.indexOf("LPJ-1") > -1) {
            return [2, 3, 8];
        }
        else if (klasse.indexOf("LP2") > -1) {
            return [2, 4, 6];
        }
        else if (klasse.indexOf("LP3") > -1) {
            return [4, 5, 9];
        }
        else if (klasse.indexOf("LPC") > -1) {
            return [3, 5, 6];
        }
        else if (klasse.indexOf("LPE") > -1) {
            return [3, 5, 6];
        }
        return [];
    }

    function getOevelseNrListVedTotalPoengLikhet(klasse) {
        const dato = new Date(getProeveDato());
        if (dato.getFullYear() >= 2026) {
            return getOevelseNrListVedTotalPoengLikhetFraOgMed2026(klasse);
        } else {
             return getOevelseNrListVedTotalPoengLikhetFoer2026(klasse)
        }
    }



    return {
        reloadFromLocalStorage: reloadFromLocalStorage,
        checkOutParti : checkOutParti,
        checkInParti : checkInParti,
        checkInDelKlasseParti : checkInDelKlasseParti,
        checkOutUnderKlasseParti: checkOutUnderKlasseParti,
        cancel : cancel,
        isPartiInLocalStorage : isPartiInLocalStorage,
        getKlassePartier : getKlassePartier,
        getAndreMuligeKlassePartier: getAndreMuligeKlassePartier,
        getParti : getParti,
        getKlasse : getKlasse,
        isCaciobPaaProeve: isCaciobPaaProeve,
        getDommerNavn : getDommerNavn,
        getProeveId : getProeveId,
        isVmMesterskap: isVmMesterskap,
        getKritikkOevelserTilDeltaker : getKritikkOevelserTilDeltaker,
        getDeltaker : getDeltaker,
        getOevelsePoengSum : getOevelsePoengSum,
        getNeste : getNeste,
        getForrige : getForrige,
        setIkkeMoedt : setIkkeMoedt,
        oppdaterCaciob: oppdaterCaciob,
        oppdaterGultKort: oppdaterGultKort,
        oppdaterRoedtKort: oppdaterRoedtKort,
        oppdaterPoeng: oppdaterPoeng,
        oppdaterKommentar: oppdaterKommentar,
        changeKlasseParti: changeKlasseParti,
        isKlasseDeltPaaOevelser: isKlasseDeltPaaOevelser,
        getFraOevelse: getFraOevelse,
        getTilOevelse: getTilOevelse,
        isHovedparti: isHovedparti,
        isInternasjonal: isInternasjonal,
        getDelPartiCheckedIn: getDelPartiCheckedIn,
        getDelPartiCheckedOut: getDelPartiCheckedOut,
        getUnderKlassePartier: getUnderKlassePartier,
        updateUnderKlassePartier: updateUnderKlassePartier,
        updatePlasseringer: updatePlasseringer,
        getDeltakerListe: getDeltakerListe,
        isUnderklasserPartierCheckedOut: isUnderklasserPartierCheckedOut,
        isPoengOgKommentarerRegistrert: isPoengOgKommentarerRegistrert
    };
}());




// WEBPACK FOOTER //
// ./src/services/resultService.js